import axios from 'axios';
import { getApiHost, getApiUrl } from 'services/EnvProvider';
import Cookies from 'universal-cookie';

const getUrl = (url: string) => getApiUrl() + url;

const getConfig = () => {
  const token = new Cookies().get('sm_user_token');

  if (!token) {
    return { headers: { Host: getApiHost() } };
  }

  return {
    headers: {
      Host: getApiHost(),
      'X-AUTH-TOKEN': token,
    },
  };
};

export const getRequest = (url: string, params = {}) =>
  axios.get(getUrl(url), { params, ...getConfig() });

export const postRequest = (url: string, postData = {}) =>
  axios.post(getUrl(url), postData, getConfig());
